var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  flex: 1;\n  flex-wrap: wrap;\n\n  @media (max-width: 767px) {\n    justify-content: center;\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  flex: 1;\n  flex-wrap: wrap;\n\n  @media (max-width: 767px) {\n    justify-content: center;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';

var SectionHeaderDefinition = styled.div(_templateObject);

SectionHeaderDefinition.displayName = 'SectionHeader';

export default SectionHeaderDefinition;